export default "__VITE_ASSET__DuqSDXQ0__"